<!-- flight option-->
<div (click)="select()"
    class="FlightResult  w-full min-h-20 px-2.5 py-4 justify-start items-center gap-2.5 inline-flex hover:bg-[#3132350a] hover:cursor-pointer"
    [ngClass]="{'bg-[#3132350a]' : isSelected}">
    <!--flight codeshares / chips-->
    <div class="w-full flex-col justify-start items-start gap-2 inline-flex">
        <div class="self-stretch justify-start items-start gap-1 inline-flex flex-wrap w-full ">
            @for(codeshare of codeshares; track $index) {
            <div class="TicketBadge  h-8 p-1 bg-gray-200 rounded-2xl justify-start items-start inline-flex">
                <div class="Label  self-stretch px-2 justify-center items-center flex">
                    <div class="Label text-black text-opacity-90 text-base font-semibold  leading-none">{{codeshare}}
                    </div>
                </div>
            </div>
            }
        </div>
    </div>
    <!--flight time / destination -->
    <div class="FlightInfoTimeDestination flex-col justify-start items-end gap-1 inline-flex">
        <div class="FlightResultTime text-black text-sm font-semibold  uppercase leading-normal">{{time | date:'HH:mm'}}
        </div>
        <div class="FlightResultDestination text-black text-base font-medium  leading-normal text-end">{{destination}}
        </div>
    </div>
</div>